import React from 'react';
import './MissionSection.css';

const MissionSection = () => {
  return (
    <section className="mission-section">
      <div className="mission-container">
        <div className="mission-content">
          <h2 className="mission-title">MISSION</h2>
          <div className="divider"></div>
          <p className="mission-text">
            Our mission is to set the standard in men's grooming through precision, discipline, and modern craft—creating confidence that endures.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;